// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q2/2023cmbyz/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getUser = (unionid: any) => {
  return http.get(`${urlPrefix}check-first&unionid=${unionid}`);
};
const getCreaten = (id: any) => {
  return http.get(`${urlPrefix}get-createn&id=${id}`);
};
const getCreatenList = (page: number) => {
  return http.get(`${urlPrefix}get-list&page=${page}`);
};
const insertQrcode = (qrlist: any) => {
  return http.get(`${urlPrefix}create-qrcode&qrlist=${qrlist}`);
};
const saveinfo = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};
export { getBaseInfo, getUser, saveinfo, getNews, getCreaten, getCreatenList, insertQrcode };

